export enum EPercentileGroup {
  TOP_10 = '10',
  TOP_20 = '20',
  TOP_30 = '30',
  TOP_40 = '40',
  TOP_50 = '50',
  NO_TOP = '50+',
}
